import { render, staticRenderFns } from "./TheAccessWalletLayout.vue?vue&type=template&id=21643d7a&"
import script from "./TheAccessWalletLayout.vue?vue&type=script&lang=js&"
export * from "./TheAccessWalletLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheAccessWalletLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports